import { render, staticRenderFns } from "./aiTextDetail.vue?vue&type=template&id=9b84709a&scoped=true"
import script from "./aiTextDetail.vue?vue&type=script&lang=js"
export * from "./aiTextDetail.vue?vue&type=script&lang=js"
import style0 from "./aiTextDetail.vue?vue&type=style&index=0&id=9b84709a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b84709a",
  null
  
)

export default component.exports